module.exports = __webpack_public_path__ + "img/caja.9e1168b.png";